module.exports = __webpack_public_path__ + "img/rot.7e25a6b6.png";